import { DI } from '../../../../apps/crossword-maker/src/shared/di';
import { ICreateCrosswordBookWordDto } from '../../Api/CrosswordBook/CrosswordBook.api.types';

export const CreateCrosswordBookWordUseCase = () => {
    const CrosswordBookRepository = DI.resolve('CrosswordBookRepository');

    return {
        async execute(data: ICreateCrosswordBookWordDto) {
            return await CrosswordBookRepository.createWord(data);
        }
    }
}
